var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header-search-form" }, [
    _c("div", { staticClass: "input-group" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.searchString,
            expression: "searchString"
          }
        ],
        ref: "searchInput",
        staticClass: "form-control header-search-input",
        attrs: {
          type: "search",
          placeholder: "Suchbegriff...",
          autofocus: _vm.isShopBuilder
        },
        domProps: { value: _vm.searchString },
        on: {
          input: [
            function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.searchString = $event.target.value
            },
            function($event) {
              return _vm.onValueChanged($event.target.value)
            }
          ],
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.search()
          },
          focus: function($event) {
            _vm.isSearchFocused = true
          },
          blur: function($event) {
            return _vm.onBlurSearchField($event)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-group-append" },
        [
          _vm._t("search-button", [
            _c(
              "button",
              {
                staticClass: "btn header-search-btn",
                attrs: { type: "submit" },
                on: {
                  click: function($event) {
                    return _vm.search()
                  }
                }
              },
              [_c("i", { staticClass: "fa fa-search" })]
            )
          ])
        ],
        2
      )
    ]),
    _vm._v(" "),
    _vm.ismobile
      ? _c("div", { staticClass: "search-mobile__results-wrapper" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.hasAutocompleteResults,
                  expression: "hasAutocompleteResults"
                }
              ],
              staticClass: "search-mobile__results"
            },
            [
              _vm._t("autocomplete-suggestions", [
                _c(
                  "div",
                  { staticClass: "autocomplete-suggestions bg-white w-100 " },
                  [
                    _c("search-suggestion-item", {
                      attrs: { "show-images": true, "suggestion-type": "item" }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "search-mobile__btn-wrapper" }, [
                _vm.ismobile
                  ? _c(
                      "button",
                      {
                        staticClass: "search-mobile__show-all-btn",
                        on: {
                          click: function($event) {
                            return _vm.search()
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$translate("Ceres::Template.homepageShowAll")
                          )
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ],
            2
          ),
          _vm._v(" "),
          !_vm.hasAutocompleteResults &&
          _vm.searchString.length >= 2 &&
          _vm.isLoading === false
            ? _c("div", { staticClass: "search-mobile-error" }, [
                _vm._v(
                  _vm._s(
                    _vm.$translate("TuningFanatics::Template.mobileSearchError")
                  )
                )
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isSearchFocused && !_vm.ismobile && _vm.searchString.length >= 2
      ? _c("div", { staticClass: "search__results-wrapper" }, [
          _c("span", {
            staticClass: "search__close",
            on: {
              click: function($event) {
                return _vm.closeSearch()
              }
            }
          }),
          _vm._v(" "),
          _vm.searchString.length >= 2 && _vm.isLoading === false
            ? _c("div", { staticClass: "search__headline" }, [
                _vm._v(
                  _vm._s(
                    _vm.$translate("TuningFanatics::Template.searchHeadline")
                  )
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.hasAutocompleteResults,
                  expression: "hasAutocompleteResults"
                }
              ]
            },
            [
              _vm._t("autocomplete-suggestions", [
                _c(
                  "div",
                  { staticClass: "autocomplete-suggestions bg-white w-100 " },
                  [
                    _c("search-suggestion-item", {
                      attrs: { "show-images": true, "suggestion-type": "item" }
                    })
                  ],
                  1
                )
              ])
            ],
            2
          ),
          _vm._v(" "),
          !_vm.hasAutocompleteResults &&
          _vm.searchString.length >= 2 &&
          _vm.isLoading === false
            ? _c("div", {
                staticClass: "search__error",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$translate("TuningFanatics::Template.searchError")
                  )
                }
              })
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }